/**
 * @generated SignedSource<<74d53757db6cc0dac9585a2a9f22aaf4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSimilarSponsoredItemsProvider_viewer$data = {
  readonly sponsoredItems: {
    readonly eligibleItemIds: ReadonlyArray<string | null> | null;
    readonly items: ReadonlyArray<{
      readonly browseUrl: string | null;
      readonly categoryCode: string | null;
      readonly ecommerceTrackingParams: any | null;
      readonly serviceId: string | null;
      readonly title: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"FavoritesProvider_item" | "PdpRespSimilarItemsGrid_similarItems" | "SharedMobileRelatedItem_item" | "SharedRespRelatedItem_item">;
    } | null> | null;
    readonly metadata: ReadonlyArray<{
      readonly clickTrackerLink: string | null;
      readonly impressionTrackerLink: string | null;
      readonly itemId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PdpSharedSimilarSponsoredItemsProvider_viewer";
};
export type PdpSharedSimilarSponsoredItemsProvider_viewer$key = {
  readonly " $data"?: PdpSharedSimilarSponsoredItemsProvider_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSponsoredItemsProvider_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "priceBookName",
    "variableName": "priceBookName"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "guestId"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "maxSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "minSponsoredItemsSteps"
    },
    {
      "kind": "RootArgument",
      "name": "numOfSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSimilarSponsoredItemsProvider_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "guestId",
          "variableName": "guestId"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Variable",
          "name": "maxItems",
          "variableName": "maxSponsoredItems"
        },
        {
          "kind": "Variable",
          "name": "minItemsSteps",
          "variableName": "minSponsoredItemsSteps"
        },
        {
          "kind": "Variable",
          "name": "pageSize",
          "variableName": "numOfSponsoredItems"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "SponsoredItems",
      "kind": "LinkedField",
      "name": "sponsoredItems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eligibleItemIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SponsoredItemsMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "impressionTrackerLink",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clickTrackerLink",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "browseUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ecommerceTrackingParams",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemsGrid_similarItems"
            },
            {
              "args": (v0/*:: as any*/),
              "kind": "FragmentSpread",
              "name": "SharedRespRelatedItem_item"
            },
            {
              "args": (v0/*:: as any*/),
              "kind": "FragmentSpread",
              "name": "SharedMobileRelatedItem_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FavoritesProvider_item"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "7f8696c47e1a64ecdbb434e9ef4b0507";

export default node;
